import { IWithSummaryModel } from "src/app/modules/common/permission/api/entity/iWithSummary.model";
import { MedicalDeviceSummaryModel } from "./medicalDeviceSummary.model";

export class MedicalDeviceModel implements IWithSummaryModel<MedicalDeviceSummaryModel> {
    summary: MedicalDeviceSummaryModel;
}

